import { render, staticRenderFns } from "./Forget_Password.vue?vue&type=template&id=727a202a&scoped=true"
import script from "./Forget_Password.vue?vue&type=script&lang=js"
export * from "./Forget_Password.vue?vue&type=script&lang=js"
import style0 from "./Forget_Password.vue?vue&type=style&index=0&id=727a202a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727a202a",
  null
  
)

export default component.exports